import { BaseModel } from "./BaseModel";

export class Match extends BaseModel {
  schema = "/match";
  constructor(params) {
    return super(params, "/match");
  }
}
